import { cloneElement, useLayoutEffect, useRef, useState } from 'react';
import { styled } from 'goober';

import { isEllipsis } from '@/helpers/other';
import { Tooltip } from '@/ui/tooltip/tooltip';

export const EllipsisTextTooltip = ({
  className,
  Component,
  text = '',
  onClick,
  onMouseDown,
  content,
  maxWidth,
}: {
  className?: string;
  text?: string | null;
  Component: React.ReactElement<Record<string, unknown>>;
  onClick?: (event: React.MouseEvent) => void;
  onMouseDown?: (event: React.MouseEvent) => void;
  content?: React.ReactNode;
  maxWidth?: string;
}) => {
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useLayoutEffect(() => {
    if (!headerRef.current) return;
    setShowTooltip(isEllipsis(headerRef.current));
  }, [headerRef.current]);

  return (
    <Tooltip
      content={content ?? <TooltipContent>{text}</TooltipContent>}
      visible={showTooltip}
      placement="top-start"
      maxWidth={maxWidth}
      className={className}
    >
      {cloneElement(Component, {
        onClick,
        onMouseDown,
        ref: headerRef,
        children: text,
      })}
    </Tooltip>
  );
};

const TooltipContent = styled('div')`
  white-space: pre-line;
  text-align: left;
  max-width: 420px;
`;
